// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.websiteConfig_container__zy8oG {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 4rem;
}
.websiteConfig_container_nav__qBhWK {
  width: 30%;
  border-radius: 2rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
}
.websiteConfig_container_nav_item__dSFyl {
  width: 100%;
  border: 1px solid var(--color-fash-primary-4);
  color: var(--color-dark);
  border-radius: 1rem;
  padding: 1rem 1rem;
  cursor: pointer;
  transition: all 0.2s;
  margin: 1rem;
}
.websiteConfig_container_nav_item_active__0cmh2 {
  width: 100%;
  border: 1px solid var(--color-fash-primary-4);
  color: var(--color-dark);
  border-radius: 1rem;
  padding: 1rem 1rem;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid var(--color-fash-primary-2);
  color: var(--color-dark);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  background-color: var(--color-fash-primary-4);
}
.websiteConfig_container_nav_item__dSFyl:hover {
  border: 2px solid var(--color-fash-primary-2);
  color: var(--color-dark);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  background-color: var(--color-fash-primary-4);
}
.websiteConfig_container_form__1UEQm {
  width: 70%;
  border-radius: 2rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
}

.websiteConfig_checks__SJ2ID {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}
@media only screen and (max-width: 56.25em) {
  .websiteConfig_checks__SJ2ID {
    flex-direction: column;
    gap: 2rem;
  }
}

.websiteConfig_dropZone__Cu2pf {
  display: flex;
  width: 38rem;
  justify-content: center;
  align-items: center;
  background-size: contain;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/websiteConfig/websiteConfig.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;AADF;AAGE;EACE,UAAA;EACA,mBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;AADJ;AAGI;EACE,WAAA;EACA,6CAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;AADN;AAGM;EACE,WAAA;EACA,6CAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EAEA,6CAAA;EACA,wBAAA;EACA,4CAAA;EACA,6CAAA;AAFR;AAKM;EACE,6CAAA;EACA,wBAAA;EACA,4CAAA;EACA,6CAAA;AAHR;AAQE;EACE,UAAA;EACA,mBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;AANJ;;AAcA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AAXF;AAYE;EAJF;IAKI,sBAAA;IACA,SAAA;EATF;AACF;;AAWA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;AARF","sourcesContent":["@import \"../variables/breakpoints\";\n\n.container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  gap: 4rem;\n\n  &_nav {\n    width: 30%;\n    border-radius: 2rem;\n    background-color: var(--color-white);\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    box-sizing: border-box;\n    padding: 3.5rem 2rem;\n\n    &_item {\n      width: 100%;\n      border: 1px solid var(--color-fash-primary-4);\n      color: var(--color-dark);\n      border-radius: 1rem;\n      padding: 1rem 1rem;\n      cursor: pointer;\n      transition: all 0.2s;\n      margin: 1rem;\n\n      &_active {\n        width: 100%;\n        border: 1px solid var(--color-fash-primary-4);\n        color: var(--color-dark);\n        border-radius: 1rem;\n        padding: 1rem 1rem;\n        cursor: pointer;\n        transition: all 0.2s;\n        // margin: 1rem;\n        border: 2px solid var(--color-fash-primary-2);\n        color: var(--color-dark);\n        box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n        background-color: var(--color-fash-primary-4);\n      }\n\n      &:hover {\n        border: 2px solid var(--color-fash-primary-2);\n        color: var(--color-dark);\n        box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n        background-color: var(--color-fash-primary-4);\n      }\n    }\n  }\n\n  &_form {\n    width: 70%;\n    border-radius: 2rem;\n    background-color: var(--color-white);\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    box-sizing: border-box;\n    padding: 3.5rem 2rem;\n\n    // @media only screen and (max-width: $bp-600) {\n    //   width: 100%;\n    // }\n  }\n}\n\n.checks {\n  display: flex;\n  justify-content: space-between;\n  margin: 1rem 0 2rem 0;\n  @media only screen and (max-width: $bp-900) {\n    flex-direction: column;\n    gap: 2rem;\n  }\n}\n.dropZone {\n  display: flex;\n  width: 38rem;\n  justify-content: center;\n  align-items: center;\n  background-size: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `websiteConfig_container__zy8oG`,
	"container_nav": `websiteConfig_container_nav__qBhWK`,
	"container_nav_item": `websiteConfig_container_nav_item__dSFyl`,
	"container_nav_item_active": `websiteConfig_container_nav_item_active__0cmh2`,
	"container_form": `websiteConfig_container_form__1UEQm`,
	"checks": `websiteConfig_checks__SJ2ID`,
	"dropZone": `websiteConfig_dropZone__Cu2pf`
};
export default ___CSS_LOADER_EXPORT___;
